// Displays agent details completion status as a Badge: "Complete", "Incomplete", or "N/A"
import React from 'react';
import { Badge, BadgeProps, Box } from '@chakra-ui/react';
import { CellProps } from '../../types';
import { CellEventsHandler } from '../formatters';
import { defaultHeaderRenderer } from '../headers';
import { IColumn } from '../types';

function getStatusBadgeProps(agentDetailsRequired?: number, agentDetailsComplete?: number): BadgeProps {
  if (agentDetailsComplete === 1) {
    return { children: 'Complete', colorScheme: 'green' };
  }
  if (!agentDetailsRequired) {
    return { children: 'N/A', variant: 'transparent' };
  }
  return { children: 'Incomplete', colorScheme: 'yellow' };
}

const AgentDetailsStatusFormatter = (cellProps: CellProps): React.JSX.Element => {
  const { colorScheme, children, variant } = getStatusBadgeProps(
    cellProps.row.agentDetailsRequired,
    cellProps.row.agentDetailsComplete,
  );

  return (
    <CellEventsHandler cellProps={cellProps}>
      <Box my={-1}>
        <Badge colorScheme={colorScheme} variant={variant}>
          {children}
        </Badge>
      </Box>
    </CellEventsHandler>
  );
};

export const AgentDetailsStatusColumn = (): IColumn => ({
  item: {
    key: 'agentDetailsStatus',
    name: 'Agent details status',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(140px, 1fr)',
    formatter: AgentDetailsStatusFormatter,
  },
  visible: ({ isAgentUser, isAgentDetailsStatusVisible }) => !!isAgentUser && !!isAgentDetailsStatusVisible,
});
